module.exports = __webpack_public_path__ + "img/image23.54eda90d.png";